export default "__VITE_ASSET__BdKKeXKe__"